<template>
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="panel scrollable" v-if="stepsLoaded">
                <div class="panel-heading">
                    <app-filter v-model="application_id" @input="getTopics" expanded :nullable="true" noAppTitle="Guide" :preSelect="$store.state.guide_application_id"></app-filter>
                </div>
                <b-table :data="topics ? topics : []" class="panel-block">
                    <template slot-scope="props">
                        <b-table-column :class="topicSelected === props.row.id ? 'topic active' :''">
                            <a href="#" @click="startWith(props.row)" class="topic">
                                {{props.row.attributes.title}}
                            </a>
                        </b-table-column>
                    </template>

                    <template #empty>
                        No topics found
                    </template>
                </b-table>
            </div>
            <div v-else-if="!stepsLoaded" class="p-lg">
                <b-loading :isFullPage="false" :active="true"></b-loading>
            </div>
        </div>
        <div class="column d-flex slider-wrapper">
            <div class="box">
                <div class="panel flex-initial" v-if="start">
                    <vue-flux
                        :options="options" 
                        :images="filtered.images" 
                        :transitions="transitions" 
                        :captions="filtered.captions" 
                        @transition-start="currentImage" 
                        @ready="loaded"
                        @created="isImageLoading = true"
                        ref="slider">

                        <template v-slot:preloader>
                            <flux-preloader/>
                        </template>
                    </vue-flux>
                </div>
                <div class="panel wrapper p-lg" v-else>
                    Click a topic to start
                </div>
                <div class="level caption-wrapper">
                    <div class="level-item">
                        <flux-caption :slider="$refs.slider" v-if="isLoaded"/>
                    </div>
                </div>
                <div class="level" v-if="start">
                    <div class="level-item level-left">
                        <flux-controls :slider="$refs.slider" v-if="isLoaded"/>
                    </div>
                    <div class="level-item level-right">
                        <b-button @click="fullScreen()" size="is-small"
                            icon-left="fullscreen"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {VueFlux,
        FluxPreloader,
        FluxControls,
        FluxCaption
        } from 'vue-flux';
import Vue from "vue";
import AppFilter from '../../../../components/AppFilter.vue'


export default {
    name:"Slider",
    data() {
        return {
            startAt:1,
            stopAt:null,
            start:false,
            steps:[],
            isLoaded:false,
            isImageLoading:false,
            columns:[
            ],
            options:{
                autoplay: false,
                allowToSkipTranstion: true,
                delay:2500,
                infinite: false,
                lazyLoad:true,
                lazyLoadAfter:20,
                allowFullscreen:true,
                autohideTime:0,
                aspectRatio:'16:9'
            },
            transitions: [
                {
                    name:'kenburn',
                    options:{
                        totalDuration:1
                    }
                }
            ],
            captions:[],
            images:[],
            page:1,
            filtered:{
                images:[],
                captions:[]
            },
            topicSelected:null,
            apps:[],
            stepsLoaded:false,
            topics:[]
        }
    },
    components: {
        VueFlux,
        FluxPreloader,
        FluxControls,
        FluxCaption,
        AppFilter
    },
    computed: {
        auth() {
            return this.$store.state.auth
        },
        application_id:{
            get(){
                return this.$store.state.guide_application_id
            },
            set(value) {
                this.$store.commit('SET_SELECTED_APP_GUIDE',value)
            }
        },
    },
    async mounted() {
        await this.getAppList()
        await this.getTopics()
        this.stepsLoaded = true
    },
    methods: {
        async getSteps() {
            Vue.$stepService.getAll(`?page=${this.page}`+(this.topicSelected ? `&topic_id=${this.topicSelected}` : '')).then(async (response)=>{
                this.page++
                await this.appendSteps(response);
                await this.appendImages(response);
                if(response.meta.pagination.total_pages>=this.page) {
                    await this.getSteps()
                }
            })

        },
        getTopics() {
            let params = '';
            if(this.application_id!==null){
                params+=`?application_id=${this.application_id}`
            }
            Vue.$topicService.topicList(params).then(async (response)=>{
                this.topics = response.data
            })
        },
        async startWith(topic=null) {
            this.isLoaded = false;
            this.topicSelected = topic.id
            this.page = 1;
            this.images = [];
            this.captions = []
            await this.getSteps()

            if(topic){
                this.start = false
                await this.reloadSlider()
                this.start = true
            }
        },
        currentImage(e){
            if(this.stopAt && e.to.index===this.stopAt){
                this.$refs.slider.stop()
            }
        },
        loaded() {
            this.$refs.slider.resize()
            this.isLoaded = true;
            if(this.startAt && this.stopAt){
                this.$refs.slider.stop()
                this.$refs.slider.show(this.startAt)
                this.$refs.slider.play()
            }
        },
        reloadSlider() {
            this.options.lazyLoad = false
        },
        goTo(type,model = null) {
            if(type==='create') this.$router.push({ name:'topics.create' })
            if(type==='edit' && model) this.$router.push({ name:'topics.edit',
                params: {
                    id: model.id
                }})
        },
        async appendSteps(response){
            let data = this.steps;
            let captions = this.captions;
            await response.data.forEach((row)=>{
                data.push(row);
                captions.push(row.attributes.name);
            })
            this.steps = data;
            this.filtered.captions = this.captions = captions
        },
        appendImages(response){
            let data = this.images;
            response.data.forEach((row)=>{
                data.push(row.attributes.path);
            })
            this.filtered.images = this.images = data;
        },
        fullScreen(){
            this.$refs.slider.Display.enterFullScreen()
        },
        async getAppList() {
            if(this.$store.state.apps.length){
                this.apps = this.$store.state.apps
            }else{
                await Vue.$appService.appList().then((response)=>{
                    this.apps = response
                    this.$store.commit('SET_APPS',response);
                })
            }
        },
    }
}
</script>
<style scoped>
    .scrollable{
        max-width: 100%;
        word-break: break-word;
    }
    .m0 {
        margin:0 !important;
    }
    .vue-flux{
        z-index: 1;
        flex: inherit;
    }
    .flux-caption.visible{
        bottom: 0px;
        position: absolute;
    }
    .topic.active{
        background-color:#363636;
    }
    .topic.active>a{
        color:white;
    }
    .topic{
        color:#363636;
    }

    .wrapper{
        background-color:#363636;
        color: white;
        height: 500px;
    }
</style>